import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Sidebar from "./sidebar";

const DashboardLayout = () => {
  return (
    <div className="app-dashboard">
      <div className="flex">
        <Sidebar />
        <div className="app-dashboard-layout w-full overflow-x-clip">
          <div className="app-dashboard-layout-inner ">
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default DashboardLayout;
